// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rights-statement-button[data-v-2c2971c5]{background:#f1f1ee;border-radius:.25rem;color:#4d4d4d;display:inline-block;font-size:.875rem;overflow:hidden;padding:.38rem .625rem;transition:.3s ease-in-out}.rights-statement-button[data-v-2c2971c5]:hover{box-shadow:2px 2px 4px 0 rgba(0,0,0,.1);cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
